import { Flipper } from 'react-flip-toolkit';
import styled from 'styled-components';

import { type Size, style } from '@genially/design-system';

import { ResponsiveText } from '../ResponsiveText/ResponsiveText';
import { Size as ParticipantSize } from './components/Player/constants';
import { Direction } from './constants';

interface WrapperProps {
  $centerAligned?: boolean;
  $direction?: Direction;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme, $centerAligned, $direction = Direction.Row }) => ({
    display: 'flex',
    flexDirection: $direction,
    justifyContent: $centerAligned ? 'center' : 'flex-start',
    alignItems: $centerAligned ? 'center' : 'flex-start',

    width: '100%',
    height: '100%',

    overflow: 'hidden auto',

    ...style.mixins.scrollbar(theme, true),

    ...style.mixins.responsive.xs.downward({
      paddingRight: theme.size.units(0.5),
      overflow: 'visible',
    }),
  }),
);

const getFlipperGap = (size: Size, participantSize: ParticipantSize) => {
  switch (participantSize) {
    case ParticipantSize.Small:
      return size.units(1);
    case ParticipantSize.Medium:
      return size.units(1.5);
    default:
      return size.units(3);
  }
};

interface StyledFlipperProps {
  $size: ParticipantSize;
  $fullWidth?: boolean;
}

export const StyledFlipper = styled(Flipper)<StyledFlipperProps>(
  ({ theme: { size }, $size, $fullWidth }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: getFlipperGap(size, $size),
    width: $fullWidth ? '100%' : undefined,

    ...style.mixins.responsive.xs.downward({
      flexDirection: 'column',
      width: '100%',
    }),
  }),
);

interface PlayerWrapperProps {
  $fullWidth?: boolean;
}

export const PlayerWrapper = styled.div<PlayerWrapperProps>(({ $fullWidth }) => ({
  width: $fullWidth ? '100%' : undefined,
}));

export const EmptyWrapper = styled.div({
  display: 'flex',
});

export const WaittingUsers = styled(ResponsiveText)(({ theme: { color } }) => ({
  color: color.content.tertiary.default(),
  textAlign: 'center',
}));
